<ng-container *ngIf="!tableEmpty && !tableLoading">
  <div *ngIf="state === 0">
    <ng-container  *ngFor="let date of commListGrouped; index as i">
      <div class="grid-auto-1-start app-space-top app-space-bottom">
        <ng-container *ngFor="let comment of filteredDataList(date); index as i">
          <div [class.app-typo-hidden]="i !== 0" class="timeline-date typo-small width-100">
            {{date.commCRD_Date | excDate: getRessource('DateTimeFormat')}}
            <br>
            {{date.commDiffCRD === 0 ? getRessource('today') : getRessource('daysago', {days: date.commDiffCRD})}}
          </div>
          <div class="timeline-element app-space-right"
               [class.tl-gray]="[0].includes(comment.commType)">
            <app-commentary-entry #VCCommText [dataToShow]="comment"></app-commentary-entry>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</ng-container>
<ng-container *ngIf="tableEmpty || tableLoading">
  <div *ngIf="tableLoading" class="splash loading">
    <div class="spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div *ngIf="tableEmpty && !tableLoading" class="splash empty">
    <p>{{getRessource('zeroRows')}}</p>
  </div>
</ng-container>
